import type { Mating } from './mating.interface';

export interface cv_WeanDirective {
    C_VocabularySource_key: number | null;
    C_WeanDirective_key: number;
    C_Workgroup_key: number;
    CreatedBy: string;
    DateCreated: Date;
    DateModified: Date;
    ElementID: string;
    IsActive: boolean;
    IsDefault: boolean;
    IsDeprecated: boolean;
    Mating: Mating[];
    ModifiedBy: string;
    SortOrder: number | null;
    Version: number;
    WeanDirective: string;
}
